import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import ExploreByConcepts from "../views/ExploreByConcepts";
import IngredientChapter from "../views/IngredientChapter";
import qs from "qs";
import ExploreByFamilies from "../views/ExploreByFamilies.vue";
import ParentRoute from "../views/ParentRoute.vue";
Vue.use(VueRouter);

export const RouteNames = {
  Home: "home",
  ExploreByConcepts: "ExploreByConcepts",
  ExploreByFamilies: "ExploreByFamilies",
  IngredientChapter: "IngredientChapter",
  HowItWorks: "HowItWorks",
};
export const children = [
  {
    path: "",
    name: "home",
    component: Home,
  },
  // {
  //   path: '/explore/by-name',
  //   name: 'explore-by-name',
  //   component: ExploreByName
  // },
  // {
  //   path: '/explore/by-ingredients',
  //   name: 'explore-by-ingredients',
  //   component: ExploreByIngredients
  // },
  {
    path: "explore/by-concepts",
    name: RouteNames.ExploreByConcepts,
    component: ExploreByConcepts,
  },
  {
    path: "explore/by-families",
    name: RouteNames.ExploreByFamilies,
    component: ExploreByFamilies,
  },
  {
    path: "chapter/ingredient",
    name: RouteNames.IngredientChapter,
    component: IngredientChapter,
  },
];
/** @type {import('vue-router').RouteConfig[]} */
export const routes = [
  {
    path: "/:installation/:defaultLang/:lang",
    component: ParentRoute,
    children,
  },

  {
    path: "/",
    redirect: "/CH02CHWC/en/en", //TODO
  },
  {
    path: "/:installation",
    redirect: "/:installation/en/en", //TODO
  },
  {
    path: "/:installation/:defaultLang",
    redirect: "/:installation/:defaultLang/:defaultLang", //TODO
  },
];
const router = new VueRouter({
  routes,
  mode: process.env.VUE_APP_ELECTRON === "true" ? "hash" : "history",
  base: process.env.BASE_URL,
  parseQuery(query) {
    return qs.parse(query);
  },
  stringifyQuery(query) {
    var result = qs.stringify(query, {
      arrayFormat: "brackets",
      encode: false,
    });
    return result ? "?" + result : "";
  },
});

//DEBERIA IR DENTRO dEL "routeWatcher" pero no se como "acceder a router" desde ahi... algo tipo "Vue.use(routeWatcher)"....
router.pushQuery = (query) => {
  let newQuery = { ...router.history.current.query, ...query };
  Object.keys(newQuery).forEach((key) => {
    if (newQuery[key] === null) delete newQuery[key];
    // else newQuery[key] = JSON.stringify(newQuery[key])
  });
  return router
    .push({ query: newQuery, state: { from: "linked-data" } })
    .catch(() => {});
};

router.beforeEach((to, from, next) => {
  console.log("router.to",to);
  if (to.query.brandAccess !== undefined) {
    console.log("SHOULD SET BRAND LOCK", to.query.brandAccess);
    if (to.query.brandAccess === "") localStorage.removeItem("brandAccess");
    else {
      localStorage.setItem(
        "brandAccess",
        JSON.stringify(to.query.brandAccess.split(",").map((id) => Number(id)))
      );
      router.app.eventTracker.emitEvent("BRAND_ACCESS", {
        brandAccess: to.query.brandAccess.split(",").map((id) => Number(id)),
      });
    }
    delete to.query.brandAccess;
    next({ name: to.name, query: to.query, replace: true });
  } else {
    next();
  }
});

export default router;
